export type DeviceState =
    | 'producing'
    | 'created'
    | 'enabled'
    | 'purchased'
    | 'rented'
    | 'validation'
    | 'packaging'
    | 'picked_up'
    | 'maintenance'
    | 'pending_shipment'
    | 'substitution'
    | 'disabled';

export type DeviceStateCategory =
    | 'created'
    | 'in_production_process'
    | 'active'
    | 'operations'
    | 'on_client'
    | 'in_maintenance'
    | 'inactive';

export const DEVICE_CATEGORIES: Record<DeviceStateCategory, DeviceState[]> = {
    created: ['created'],
    in_production_process: ['producing', 'validation', 'packaging'],
    active: ['enabled'],
    operations: ['pending_shipment', 'picked_up'],
    on_client: ['rented', 'purchased', 'substitution'],
    in_maintenance: ['maintenance'],
    inactive: ['disabled'],
};


export const getStatusColor = (state: DeviceState | string): string => {
    switch (state) {
        case 'producing':
            return '#FFA500'; // Naranja para "producing" (activo en producción)
        case 'enabled':
            return '#4CAF50'; // Verde para "enabled" (activo)
        case 'disabled':
            return '#B0BEC5'; // Gris claro para "disabled" (inactivo)
        case 'purchased':
            return '#1976D2'; // Azul para "purchased" (comprado)
        case 'rented':
            return '#00BCD4'; // Azul claro para "rented" (alquilado)
        case 'created':
            return '#B0BEC5'; // Gris claro para "created" (recientemente creado)
        case 'packaging':
            return '#FFB74D'; // Naranja claro para "packaging"
        case 'validation':
            return '#FFC107'; // Amarillo para "validation"
        case 'picked_up':
            return '#17A2B8'; // Azul para "picked up" (recogido)
        case 'maintenance':
            return '#FF5722'; // Naranja rojizo para "maintenance" (en mantenimiento)
        case 'pending_shipment':
            return '#FFD700'; // Dorado para "pending shipment" (pendiente de envío)
        case 'substitution':
            return '#33C7FF'; // Azul claro para "substitution" (dispositivo de sustitución)
        default:
            return '#004e78'; // Color primario como valor predeterminado
    }
};